var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMyprofileIcon = function SvgMyprofileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-merch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.767 2.743a8.476 8.476 0 1 0 2.485 6 8.475 8.475 0 0 0-2.485-6Zm-.291 11.7c-.1.1-.209.2-.316.3a5.525 5.525 0 0 0-10.778 0c-.107-.1-.213-.2-.316-.3a8.067 8.067 0 1 1 11.41 0Zm-3.084-7.188a2.622 2.622 0 1 1-.766-1.856 2.626 2.626 0 0 1 .766 1.856Z",
    fillRule: "evenodd"
  })));
};
export default SvgMyprofileIcon;